<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Almoxarifado/Protocolo Entrega</label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col cols="12" sm="2">
          <v-btn
            color="info"
            to="/protocoloEntrega/criar"
            v-if="isAllowed(idModulo)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>

        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                <v-avatar size="25" color="primary">
                  <span class="white--text text-h6">TD</span>
                </v-avatar>
                <div class="ma-1 text-h5">Todas</div>
              </template></v-radio
            >
            <v-radio value="PG">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">PG</span>
                </v-avatar>
                <div class="ma-1 text-h5">Protocolo Gerado</div>
              </template>
            </v-radio>
            <v-radio value="B">
              <template v-slot:label>
                <v-avatar color="blue-grey lighten-4" size="25">
                  <span class="white--text text-h6">B</span>
                </v-avatar>
                <div class="ma-1 text-h5">Baixado</div>
              </template>
            </v-radio>
            <v-radio value="I">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <div class="ma-1 text-h5">Inativa</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="text-right" cols="12" sm="2">
          <v-btn
            @click="baixarlista()"
            v-if="protocolosEntrega.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
        ><template v-slot:item.status="{ item }">
          <v-avatar v-if="item.status == 'PG'" color="green" size="24">
            <span class="white--text text-h5">PG</span>
          </v-avatar>
          <v-avatar
            v-else-if="item.status == 'B'"
            color="grey darken-1"
            size="24"
          >
            <span class="white--text text-h5">B</span>
          </v-avatar>
          <v-avatar v-else color="blue-grey lighten-4" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.data="{ item }">
          <span>{{
            item.data == null
              ? ""
              : new Date(item.data).toLocaleString().replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
        <template v-slot:item.actions="{ item }"
          ><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span>Visualizar em PDF</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(idModulo) && item.status == 'PG'"
              >Editar</span
            >
            <span v-else>Ver</span>
          </v-tooltip>
          <v-tooltip v-if="isInactive(idModulo)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                class="mr-2"
                @click="inativar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!protocoloPodeSerInativado(item)"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Inativar</span>
          </v-tooltip>
          <v-tooltip v-if="isAllowed(idModulo)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="baixar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!(item.status === 'PG')"
              >
                mdi-check-bold
              </v-icon>
            </template>
            <span v-if="isAllowed(idModulo)">Baixar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">{{ textoTituloFormatado }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12"
                  ><v-subheader
                    ><strong
                      >{{ textoSubtituloFormatado }}</strong
                    ></v-subheader
                  >
                  <hr />
                  <v-textarea
                    v-if="acao == 'inativar'"
                    label="Se sim justifique o motivo..."
                    v-model="justificativa"
                    clear-icon="mdi-close-circle"
                    :rules="[(v) => !!v || 'A justificativa é obrigatória']"
                    required
                    rows="2"
                    auto-grow
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <v-row align="center-left">
              <v-col class="text-right">
                <v-btn @click="showModal = false" color="error" class="mr-4">
                  Voltar
                </v-btn>
                <v-btn @click="realizarAcao()" color="success" class="mr-4">
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  downloadLista,
  getPdf,
} from "../../../services/protocoloEntregaService";
import { canInactivateModule, getUserRoles, isLoggedUserAdmin } from "@/services/loginService";
import { abrirJanelaPdf } from "@/services/pdfHelper";
import {
  baixarProtocoloEntregaAsync,
  inativarProtocoloEntregaAsync,
} from "../../../services/protocoloEntregaService";
import { saveAs } from "file-saver";

export default {
  name: "listaProtocolosEntrega",
  data() {
    return {
      overlay: false,
      idModulo: 19,
      loading: false,
      search: "",
      valid: true,
      selectedFilter: "0",
      showAtivo: false,
      active_tab: 2,
      acao: null,
      item: null,
      showModal: false,
      justificativa: null,
      headers: [
        {
          text: "Protocolo",
          align: "start",
          value: "id",
        },
        { text: "Data", value: "data" },
        { text: "Unidade", value: "unidadeAdm" },
        { text: "Responsável", value: "usuario" },
        { text: "Motorista", value: "motorista" },
        { text: "Status", value: "status" },
        { text: "", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        id: [],
        unidadeAdm: [],
        motorista: [],
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
    };
  },
  computed: {
    ...mapState("protocoloEntrega", ["protocolosEntrega"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    filteredList() {
      const searchLower = this.search.toLowerCase();

      return this.protocolosEntrega
        .filter((pe) => {
          // 1. Filtro por texto digitado
          const buscaTexto =
            pe.id.toString().toLowerCase().includes(searchLower) ||
            (pe.unidadeAdm || "").toLowerCase().includes(searchLower) ||
            (pe.motorista || "").toLowerCase().includes(searchLower) ||
            (pe.itens || []).some((i) =>
              i.produto?.toLowerCase().includes(searchLower) ||
              i.centroCusto?.toLowerCase().includes(searchLower) ||
              i.codigo?.toLowerCase().includes(searchLower)
            );

          // 3. Filtros refinados (filters)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            return this.filters[f].includes(pe[f]);
          });

          // 4. Filtro por status (se não for "0")
          const statusOk =
            this.selectedFilter === "0" || pe.status === this.selectedFilter;

          return buscaTexto && filtrosOk && statusOk;
        })
        .sort((a, b) => b.id - a.id);
    },
    textoTituloFormatado() {
      return this.acao != null
        ? this.capitalizarPrimeiraLetra(this.acao) + " Protocolo Entrega"
        : "" + " Protocolo Entrega";
    },
    textoSubtituloFormatado() {
      return (
        "Deseja realmente " +
        (this.acao != null ? this.capitalizarPrimeiraLetra(this.acao) : "") +
        " o Protocolo de Entrega:" +
        (this.item != null ? this.item.id : "") +
        "?"
      );
    },
  },
  methods: {
    ...mapActions("protocoloEntrega", [
      "atualizarProtocolosEntrega",
      "atualizarProtocoloEntrega",
      "updateProtocoloEntrega",
    ]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("centroCusto", ["atualizarCentrosCusto"]),
    editar(protocoloEntrega) {
      this.atualizarProtocoloEntrega(protocoloEntrega);
      if (this.isAllowed(this.idModulo) && protocoloEntrega.status == "PG") {
        this.$router.push({
          path: "/protocoloEntrega/editar",
          query: {
            ...this.$route.query,
            page: String(this.options?.page || 1),
          },
        });
      } else {
        this.$router.push({
          path: "/protocoloEntrega/ver",
          query: {
            ...this.$route.query,
            page: String(this.options?.page || 1),
          },
        });
      }
    },
    baixarlista() {
      const blob = this.gerarExcel();
      const nome_arquivo = "protocolosEntrega.xlsx";
      saveAs(blob, nome_arquivo);
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarProtocolosEntrega();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
    doAjax() {
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.centrosCusto || this.centrosCusto.length == 0) {
        this.atualizarCentrosCusto();
      }
    },
    show(protocolo) {
      getPdf(protocolo.id, abrirJanelaPdf());
    },
    isInactive(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return canInactivateModule(id) || (regra != null && regra.inativar);
    },
    isAdmin() {
      return isLoggedUserAdmin();
    },
    protocoloPodeSerInativado(item) {
      return item.status === "PG" || (this.isAdmin() && !["B", "I"].includes(item.status));
    },
    baixar(item) {
      this.acao = "baixar";
      this.item = item;
      this.showModal = true;
    },
    inativar(item) {
      this.acao = "inativar";
      this.item = item;
      this.showModal = true;
    },
    async realizarAcao() {
      if (this.acao == "inativar" && !this.$refs.form2.validate()) {
        return;
      }
      this.showModal = false;
      this.overlay = true;
      try {
        if (this.acao == "inativar") {
          this.item.justificativa = this.justificativa;
          const resposta = await inativarProtocoloEntregaAsync(
            this.item.id,
            this.item.saida,
            this.item.idUnidadeAdm,
            this.item.veiculo,
            this.item.motorista,
            this.item.observacao,
            this.item.ativo,
            this.item.justificativa,
            this.item.itens
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.$store.dispatch("ui/showSnackbar", {
              text: "Protocolo inativado!",
              color: "success",
              timeout: 3000,
            });
            this.item.status = "I";
            this.updateProtocoloEntrega(this.item);
          }
        } else {
          const resposta = await baixarProtocoloEntregaAsync(
            this.item.id,
            this.item.saida,
            this.item.idUnidadeAdm,
            this.item.veiculo,
            this.item.motorista,
            this.item.observacao,
            this.item.ativo,
            this.item.itens
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message,
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.$store.dispatch("ui/showSnackbar", {
              text: "Protocolo baixado!",
              color: "success",
              timeout: 3000,
            });
            this.item.status = "B";
            this.updateProtocoloEntrega(this.item);
          }
        }
      } finally {
        this.overlay = false;
      }
    },
    capitalizarPrimeiraLetra(texto) {
      return texto
        .split(" ") // Divide o texto em palavras
        .map(
          (palavra) =>
            palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase()
        ) // Capitaliza a primeira letra e coloca o resto em minúsculas
        .join(" "); // Junta as palavras novamente em uma string
    },
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "Protocolo" },
        { chave: "data", cabecalho: "Data" },
        { chave: "unidadeAdm", cabecalho: "Unidade" },
        { chave: "motorista", cabecalho: "Motorista" },
        { chave: "status", cabecalho: "Status" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "data") {
              return new Date(item[c.chave])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
            } else if (c.chave === "id") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col, i) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    this.obterLista();
    this.doAjax();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }

    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
};
</script>
